/**
 * 法规知识库读取 + 项目特征 → 适用 topic 选择器（前端入口）。
 *
 * 数据源：scripts/build-compliance-index.mjs 生成的 __data__.json
 * 逻辑核：complianceKnowledgeCore.js（纯函数，可在 Node 脚本 / 测试中复用）
 * 上游消费：synthesizeComplianceRisk.js（A2 阶段）
 */

import kbData from './compliance/__data__.json';
import { createKnowledge, topicMatches as _topicMatches } from './complianceKnowledgeCore';

const k = createKnowledge(kbData);

export const loadAllTopics = k.loadAllTopics;
export const getKbMetadata = k.getKbMetadata;
export const getJurisdictionTopics = k.getJurisdictionTopics;
export const getTopic = k.getTopic;
export const selectRelevantTopics = k.selectRelevantTopics;

// 纯函数直接转发，无需绑定 kbData
export const topicMatches = _topicMatches;
